var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1302,
    cy: 13,
    r: 12.6087,
    fill: "#F3F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0486 8.93799C18.6239 9.16866 18.1746 9.32063 17.7148 9.3891C18.198 9.0354 18.5614 8.47348 18.7368 7.80873C18.2799 8.14267 17.7809 8.37698 17.2612 8.50161C17.0423 8.21489 16.7791 7.98679 16.4875 7.83118C16.1959 7.67557 15.882 7.59571 15.565 7.59644C14.2813 7.59644 13.2425 8.87607 13.2425 10.4535C13.2416 10.6729 13.2617 10.8917 13.3025 11.1051C12.382 11.0512 11.4807 10.7576 10.6561 10.2433C9.83163 9.72903 9.10207 9.00526 8.51416 8.11832C8.3079 8.55295 8.19882 9.04886 8.19832 9.55421C8.19832 10.5449 8.61181 11.4206 9.23617 11.9336C8.86625 11.9226 8.50392 11.8003 8.17992 11.5768V11.6122C8.17992 12.998 8.9819 14.1508 10.0433 14.4133C9.84374 14.4798 9.63805 14.5135 9.43148 14.5135C9.2849 14.5138 9.13866 14.496 8.99487 14.4604C9.28995 15.5956 10.1488 16.4212 11.1661 16.4447C10.3395 17.2411 9.32454 17.6715 8.28087 17.6683C8.09562 17.668 7.91054 17.6542 7.72656 17.6271C8.78829 18.4745 10.0225 18.9228 11.2822 18.9185C15.56 18.9185 17.8971 14.5636 17.8971 10.7867C17.8971 10.6628 17.8945 10.539 17.8898 10.4181C18.3434 10.0148 18.7358 9.51356 19.0486 8.93799Z",
    fill: "#064A72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup29);
export default __webpack_public_path__ + "static/media/Group 29.96760be49951aa836868031cc7279585.svg";
export { ForwardRef as ReactComponent };